import $ from 'jquery';
import WorkPageController from './work/WorkPageController';
import TyrePageController from './tyres/TyrePageController';

$(function () {
  const onWorkPage = $('.v2-work-page-container').length > 0;
  if (onWorkPage) {
    const workPageController = new WorkPageController();
    new TyrePageController(workPageController.workPage).init();
    workPageController.init();
  }

  window.Application.adjustPageToFitHeader = function () {
    $('body.page-booking').css('padding-top', $('.fixed-header').height());
  };
  $(window).on('resize', window.Application.adjustPageToFitHeader).trigger('resize');
});
